import axios from "./axios";
const api = {};

api.adminLogin = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/login`;
  return axios.post(url, body);
};
api.logout = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employee/logout`;
  return axios.post(url, body);
};
api.verifyAdminSession = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/admin/is-session-valid`;
  return axios.post(url, body);
};
api.uploadPDF = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload-pdf`;
  return axios.post(url, body);
};
api.addVehicle = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/vehicles`;
  return axios.post(url, body);
};
api.getVehicle = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/vehicles`;
  return axios.get(url);
};
api.deleteVehicle = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/vehicles/${id}`;
  return axios.delete(url);
};
api.addDriver = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/drivers`;
  return axios.post(url, body);
};
api.getDrivers = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/drivers`;
  return axios.get(url);
};
api.updateDriver = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/drivers/${id}`;
  return axios.put(url, body);
};
api.deleteDrivers = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/drivers/${id}`;
  return axios.delete(url);
};
api.addRoute = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/routes`;
  return axios.post(url, body);
};
api.getRoute = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/routes`;
  return axios.get(url);
};
api.updateRoute = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/routes/${id}`;
  return axios.put(url, body);
};
api.deleteRoute = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/routes/${id}`;
  return axios.delete(url);
};
api.addStudents = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/students`;
  return axios.post(url, body);
};
api.getStudents = function (params) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/Students`;
  return axios.get(url, params);
};
api.updateStudents = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/students/${id}`;
  return axios.put(url, body);
};
api.deleteStudents = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/Students/${id}`;
  return axios.delete(url);
};
api.getEmployee = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/employees/${id}`;
  return axios.get(url);
};
api.uploadFile = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/file/upload`;
  return axios.post(url, body);
};

api.addFuel = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fuel`;
  return axios.post(url, body);
};
api.getFuel = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fuel`;
  return axios.get(url, params);
};
api.updateFuel = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fuel/${id}`;
  return axios.put(url, body);
};
api.deleteFuel = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fuel/${id}`;
  return axios.delete(url);
};
api.addPayMethod = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment-methods`;
  return axios.post(url, body);
};
api.getPayMethod = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment-methods`;
  return axios.get(url);
};
api.updatePayMethod = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment-methods/${id}`;
  return axios.put(url, body);
};
api.deletePayMethod = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/payment-methods/${id}`;
  return axios.delete(url);
};
api.addMaintenance = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/maintenance`;
  return axios.post(url, body);
};
api.getMaintenance = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/maintenance`;
  return axios.get(url, params);
};
api.updateMaintenance = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/maintenance/${id}`;
  return axios.put(url, body);
};
api.getMaintenanceByVehicle = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/maintenance${id}`;
  return axios.get(url);
};
api.delMaintenance = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/maintenance/${id}`;
  return axios.delete(url);
};
api.getSalary = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/salary`;
  return axios.get(url, params);
};
api.generateSalary = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/salary`;
  return axios.post(url, body);
};
api.deleteSalary = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/salary/${id}`;
  return axios.delete(url);
};
api.updateSalary = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/salary/${id}`;
  return axios.put(url, body);
};
api.addLoan = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/loan`;
  return axios.post(url, body);
};
api.getLoan = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/loan`;
  return axios.get(url, params);
};
api.updateLoan = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/loan/${id}`;
  return axios.put(url, body);
};
api.deleteLoan = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/loan/${id}`;
  return axios.delete(url);
};
api.getDashboard = function () {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/dashboard`;
  return axios.get(url);
};

api.getFees = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fee`;
  return axios.get(url, params);
};
api.recordFeePayment = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fee/${id}/pay`;
  return axios.post(url, body);
};
api.getFeePayments = function (feeId) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fee/${feeId}/payments`;
  return axios.get(url);
};
api.searchFeeByReceipt = function (receiptNo) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fee/receipt/${receiptNo}`;
  return axios.get(url);
};
api.searchFeePayments = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/fee/search`;
  return axios.get(url, params);
};

// Entry APIs
const E = `${process.env.REACT_APP_SERVER_BASE_URL}/entry`;
api.getClassEntries   = (p) => axios.get(`${E}/class`, p);
api.addClassEntry     = (b) => axios.post(`${E}/class`, b);
api.updateClassEntry  = (id, b) => axios.put(`${E}/class/${id}`, b);
api.deleteClassEntry  = (id) => axios.delete(`${E}/class/${id}`);

api.getVehicleEntries  = (p) => axios.get(`${E}/vehicle`, p);
api.addVehicleEntry    = (b) => axios.post(`${E}/vehicle`, b);
api.updateVehicleEntry = (id, b) => axios.put(`${E}/vehicle/${id}`, b);
api.deleteVehicleEntry = (id) => axios.delete(`${E}/vehicle/${id}`);

api.getDailyRecords   = (p) => axios.get(`${E}/daily`, p);
api.addDailyRecord    = (b) => axios.post(`${E}/daily`, b);
api.updateDailyRecord = (id, b) => axios.put(`${E}/daily/${id}`, b);
api.deleteDailyRecord = (id) => axios.delete(`${E}/daily/${id}`);

api.addEnquiry = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/enquiry`;
  return axios.post(url, body);
};
api.getEnquiries = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/enquiry`;
  return axios.get(url, params);
};
api.updateEnquiry = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/enquiry/${id}`;
  return axios.put(url, body);
};
api.deleteEnquiry = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/enquiry/${id}`;
  return axios.delete(url);
};

api.addBooking = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/booking`;
  return axios.post(url, body);
};
api.addBookingManual = function (body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/booking/manual`;
  return axios.post(url, body);
};
api.getBookings = function (params = {}) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/booking`;
  return axios.get(url, params);
};
api.updateBooking = function (id, body) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/booking/${id}`;
  return axios.put(url, body);
};
api.deleteBooking = function (id) {
  const url = `${process.env.REACT_APP_SERVER_BASE_URL}/booking/${id}`;
  return axios.delete(url);
};

const S = `${process.env.REACT_APP_SERVER_BASE_URL}/support`;
api.supportLogin          = (body) => axios.post(`${S}/login`, body);
api.verifySupportSession  = (body) => axios.post(`${S}/is-session-valid`, body);
api.getSupportMembers     = ()     => axios.get(S);
api.addSupportMember      = (body) => axios.post(S, body);
api.updateSupportMember   = (id, body) => axios.put(`${S}/${id}`, body);
api.deleteSupportMember   = (id)   => axios.delete(`${S}/${id}`);

export default api;
